import * as types from '../actions/actionType';
import dayjs from 'utils/dayjs';

const initialState = {
    isLoading: true,
    dateSelection: {
        year: dayjs().format('YYYY'),
        month: '01',
    },
};
const propertyReducerByYear = (state = { ...initialState }, action) => {
    switch (action.type) {
        case types.GET_PROPERTY_BY_YEAR:
            return {
                ...state,
                filters: {
                    startDate: action.startDate,
                    endDate: action.endDate,
                    lyStartDate: action.lyStartDate,
                    lyEndDate: action.lyEndDate,
                },
                isLoading: true,
            };
        case types.GET_PROPERTY_BY_YEAR_SUCCESS:
            return {
                ...state,
                isLoading: false,
                ...action.payload,
            };
        default:
            return state;
    }
};

export default propertyReducerByYear;
